import React from "react";

/**
 * Skeleton do estado inicial da aba "Laboratório de IA". As duas
 * ferramentas internas (Predição/Hashtags) não têm fetch no mount — cada
 * uma só busca dados sob demanda ao usuário submeter um formulário — então
 * este skeleton só precisa cobrir o breve carregamento inicial da página
 * (mesmo padrão do header, sem geometria de resultado).
 */
const AILabSkeleton: React.FC = () => (
  <div className="space-y-2 animate-pulse">
    <div className="flex items-center justify-between gap-3 min-h-[52px] bg-white/70 border border-purple-200 rounded-2xl px-4 sm:px-5 py-2.5 shadow-xs">
      <div className="flex items-center gap-2">
        <div className="w-5 h-5 bg-purple-200 rounded-sm shrink-0" />
        <div>
          <div className="h-4 w-40 bg-gray-300 rounded-sm mb-1.5" />
          <div className="h-2.5 w-52 bg-gray-200 rounded-sm" />
        </div>
      </div>
      <div className="h-9 w-40 bg-gray-100 rounded-lg" />
    </div>
    <div className="bg-white border border-purple-200 rounded-xl p-3 h-[320px]" />
  </div>
);

export default AILabSkeleton;
